import React, { useState, useEffect } from 'react';
import Button from 'components/generics/Button';
import InputLabel from 'components/generics/InputLabel';


const EditQuoteStatusForm = props => {
    const [ quoteStatus, setQuoteStatus ] = useState(props.currentQuoteStatus)
  
    useEffect(
      () => {
        setQuoteStatus(props.currentQuoteStatus)
      },
      [ props ]
    )
    // You can tell React to skip applying an effect if certain values haven’t changed between re-renders. [ props ]
  
    const handleInputChange = (name, value) => {
      setQuoteStatus({ ...quoteStatus, [name]: value })
    }
  
    return (
      <form className="form-client"
        onSubmit={event => {
          event.preventDefault()
          props.handleUpdateQuoteStatus(quoteStatus.id, quoteStatus)
        }}
      >

      <InputLabel
				name="name"
				type="text"
				value={quoteStatus.name}
				defaultStyle='secondary'
				label="Nom"
				onChange={(e) => { handleInputChange('name', e); }}/>
			<InputLabel
				name="description"
				type="text"
				value={quoteStatus.description}
				defaultStyle='secondary'
				label="Description"
				onChange={(e) => { handleInputChange('description', e); }}/>

        <div className="div-button">
          <Button
            type="submit"
            defaultStyle="btn btn-primary"
            text="Enregistrer"
            textColor="primary"
          />
          <Button 
            type="button"
            text="Annuler"  
            onClick={() => props.setEditing(false)} 
            defaultStyle="btn btn-secondary"
          />
        </div>
      </form>
    )
  }

export default EditQuoteStatusForm;
